<template>
  <generic-column-name-edition
    :value="generic_column_name"
    v-bind="$props"
    v-on="listeners_for_generic_column_name_edition"
    @input="validate_edition($event)"
  >
    <template #right_element="{in_edition}">
      <b-form-select
        v-if="in_edition"
        v-model="operation"
        :options="operation_options"
      />
      <span v-else>
        {{ operation }}
      </span>
    </template>
  </generic-column-name-edition>
</template>

<script>
import _ from 'lodash'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'
import {
  GenericColumnName,
  GenericColumnNameForUnicity,
} from '@/components/object_model.js'

export default {
  name: 'GenericColumnNameEditionForUnicity',
  components: {
    GenericColumnName,
    GenericColumnNameEdition,
  },
  props: [...GenericColumnNameEdition.props],
  data() {
    return {
      generic_column_name: undefined,
      type: '',
      operation_options: [
        { value: '', text: this.$t('wanted_operation') },
        { value: 'min', text: 'Minimum' },
        { value: 'max', text: 'Maximum' },
        { value: 'mode', text: 'Mode' },
      ],
    }
  },

  computed: {
    listeners_for_generic_column_name_edition() {
      return _.omit(this.$listeners, 'input')
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.generic_column_name = _.cloneDeep(nv.generic_column_name)
          this.operation = nv.operation
        }
      },
    },
  },

  methods: {
    validate_edition(generic_column_name) {
      let new_value = new GenericColumnNameForUnicity(
        generic_column_name.name,
        generic_column_name.contains_metavariables,
        this.operation
      )
      this.$emit('input', new_value)
    },
  },
}
</script>
